export default __webpack_public_path__ + "static/media/no-datas-found.22204fdc.png";